import {ITheme} from 'contexts/ThemeContext';
import {useWindowDimensions, StyleSheet, Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

const TABS_COUNT = 7;
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.23,
  shadowRadius: 2.62,

  elevation: 4,
};

export default ({colors, typography}: ITheme) => {
  const width = useWindowDimensions().width;

  return CreateResponsiveStyle(
    {
      safeArea: {
        flex: 1,
        backgroundColor: colors.dirtyWhite,
      },
      containerStyle: {
        flex: 1,
        flexDirection: Platform.OS === 'web' ? 'row' : 'column',
        backgroundColor: colors.dirtyWhite,
      },
      webLeftPart: {
        width: 440,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        backgroundColor: colors.dirtyWhite,
      },
      webRightPart: {
        flex: 1,
        backgroundColor: colors.white,
      },
      smallCalendarContainer: {
        width: '100%',
        height: 200,
        paddingBottom: 20,
        paddingTop: 15,
        backgroundColor: colors.white,
        ...shadow,
      },
      smallCalendarDateTextStyle: {
        fontSize: 15,
        color: colors.cornflowerBlue,
        ...typography.interMedium,
      },
      dateAndButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: 16,
        marginRight: 18,
        backgroundColor: colors.white,
      },
      calendarImageContainer: {
        width: 25,
        height: 25,
        borderRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.white,
      },
      calendarImage: {
        width: 24,
        height: 24,
      },
      segmentedControlWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 8,
        width: width,
        backgroundColor: colors.white,
        paddingVertical: 18,
      },

      segmentedControlButton: {
        ...StyleSheet.absoluteFillObject,
        position: 'absolute',
        width: 33,
        top: 0,
        height: 73,
        marginTop: 18,
        marginLeft: width / TABS_COUNT - 45,
        marginVertical: 2,
        backgroundColor: colors.cornflowerBlueWithOpacity(0.09),
        borderRadius: 27,
        ...(Platform.OS == 'ios' ? shadow : {}),
      },
      modalView: {
        justifyContent: 'flex-end',
        paddingBottom: 37,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
};
